import api from '../utils/api';

export const authService = {
  login: async (email, password) => {
    const response = await api.post('/auth/login', { email, password });
    // Handle both 'token' and 'access_token' from API
    const token = response.data.token || response.data.access_token;
    if (token && response.data.user) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  register: async (userData) => {
    // Map form data to API format
    const registerData = {
      email: userData.email,
      password: userData.password,
      firstName: userData.firstName,
      lastName: userData.lastName,
      phone: userData.phone,
      fleetName: userData.fleetName,
      businessRegistrationNumber: userData.businessRegistrationNumber,
      address: userData.address,
      fleetPhone: userData.fleetPhone || userData.phone,
      fleetEmail: userData.fleetEmail || userData.email,
    };
    const response = await api.post('/auth/register', registerData);
    const token = response.data.token || response.data.access_token;
    if (token && response.data.user) {
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: async () => {
    try {
      // Fleet API might not have logout endpoint, but we'll try
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    }
  },

  getProfile: async () => {
    const response = await api.get('/auth/profile');
    return response.data;
  },

  /** Personal account fields (first_name, last_name, phone, preferred_language, etc.) */
  updateAccountProfile: async (payload) => {
    const response = await api.put('/auth/profile', payload);
    return response.data;
  },

  changePassword: async ({ currentPassword, newPassword }) => {
    const response = await api.post('/auth/change-password', {
      currentPassword,
      newPassword,
    });
    return response.data;
  },

  getStoredUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  getToken: () => {
    return localStorage.getItem('token');
  },
};
